import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';

export default function (element, data) {
    element.simplebar = new SimpleBar(element, {
        autoHide: false
    });
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary
